import Skeleton from "components/BaseWidgets/skeleton";
import MiniPlanCard from "../MiniPlanCard";
import "./style.scss";
import { PlansClose, PlansTick } from "assets/icons";
import { useFeatureList, usePlansList } from "hooks/api/usePlans";
import { getFormattedPlans } from "components/Plans/utils";

function SubscriptionsTab({ onOk, isPending }) {
  const { data: subPlans = [], isLoading } = usePlansList({ plan_type: 1, see_all: true });
  const { data: featureData = {} } = useFeatureList(1);
  const subscriptionPlans = subPlans?.data?.plan_data ?? [];
  const allFeatures = featureData?.plan_feature || [];
  const formattedPlans = getFormattedPlans(subscriptionPlans, allFeatures);

  return (
    <div className="mt-6 flex flex-col gap-16 subscriptions-tab">
      <div className="flex flex-col gap-2 items-center">
        <h1 className="main-title title text-center">
          Find your perfect match with our premium plans
        </h1>
        <p className="main-description tab-description text-center">
          Upgrade to enjoy exclusive benefits and make your matrimonial search
          more seamless and effective..
        </p>
      </div>
      <div className="feature-table">
        {/* feature header */}
        <div className="feature-header">
          <div className="feature-label"></div>
          <div className="feature-columns">
            {isLoading
              ? Array.from({ length: 3 }).map((_, index) => (
                  <div className="feature-cell" key={`skeleton-${index}`}>
                    <Skeleton
                      height={220}
                      width={220}
                      className="rounded-lg"
                      label={false}
                    />
                  </div>
                ))
              : formattedPlans.map((plan, index) => (
                  <div className={`feature-cell plan-column ${
                    plan.is_popular ? "highlight-column" : ""
                  }`} key={plan.key}>
                    <MiniPlanCard
                      key={plan.key}
                      onOk={() => onOk(plan)}
                      data={plan}
                      compactMode
                      isLoading={isPending}
                      isPopular={plan.is_popular}
                    />
                  </div>
                ))}
          </div>
        </div>

        {/* Feature rows */}
        {allFeatures.map((feature, rowIndex) => (
          <div
            className={`feature-row ${rowIndex < 2 ? "highlight-row" : ""}`}
            key={feature.id}
          >
            <div className="feature-label">{feature.name}</div>
            <div className="feature-columns">
              {formattedPlans.map((plan) => {
                const hasFeature = plan.plan_feature_ids.includes(feature.id);
                return (
                  <div
                    className="feature-cell"
                    key={`${plan.key}-${feature.id}`}
                  >
                    {hasFeature ? <PlansTick /> : <PlansClose />}
                  </div>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default SubscriptionsTab;
